import { Dispatch, SetStateAction } from "react";
import { useMedia } from "react-use";
import { MOBILE_MAX_WIDTH } from "../../../constant";
import { ViewType, isViewTypeForSecond } from "../../../types/viewType";
import GeneListTab from "./GeneListTab";
import styles from "./geneListTabsArea.module.scss";

type Props = {
  viewType: ViewType;
  setViewType: Dispatch<SetStateAction<ViewType>>;
  count: number;
  onClickShuffle: () => void;
  onClickToggleFilterBtn: () => void;
  isFilterBtnDisable: boolean;
};

const GeneListTabsArea = ({
  viewType,
  setViewType,
  count,
  onClickShuffle,
  onClickToggleFilterBtn,
  isFilterBtnDisable,
}: Props) => {
  const isMobile = useMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`, false);

  const toggleFilterOpen = () => {
    onClickToggleFilterBtn();
  };

  return (
    <div
      className={`flex justify-between ${
        isMobile
          ? "flex-col"
          : "mb-[16px] relative after:absolute after:bottom-0 after:w-full after:h-[2px] after:bg-white"
      }`}
    >
      <div
        className={`flex justify-between box-border ${
          isMobile
            ? "relative h-[50px] items-center after:absolute after:bottom-0 after:mx-[calc(50%-50vw)] after:w-screen after:h-[1px] after:bg-white"
            : "h-[48px]"
        }`}
      >
        <div className={`flex ${isMobile ? "ml-[-16px]" : ""}`}>
          <GeneListTab
            text={"Neural Elective N"}
            isActive={!isViewTypeForSecond(viewType)}
            onClick={() => setViewType("NORMAL")}
          />
          <GeneListTab
            text={"NEN Nascent"}
            isActive={isViewTypeForSecond(viewType)}
            onClick={() => setViewType("SECOND_NORMAL")}
          />
        </div>
        {isMobile && (
          <button
            type="button"
            className={styles["button"] + " mr-[-8px]"}
            onClick={toggleFilterOpen}
            disabled={isFilterBtnDisable}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.265947 2.0125C2.80472 5.25 7.49265 11.25 7.49265 11.25V18.75C7.49265 19.4375 8.05822 20 8.74947 20H11.2631C11.9544 20 12.5199 19.4375 12.5199 18.75V11.25C12.5199 11.25 17.1953 5.25 19.7341 2.0125C20.375 1.1875 19.7843 0 18.7412 0H1.25883C0.215675 0 -0.37503 1.1875 0.265947 2.0125Z"
                fill="white"
              />
            </svg>
          </button>
        )}
      </div>
      <div
        className={`flex items-center ${
          isMobile
            ? "justify-between relative h-[44px] after:absolute after:bottom-0 after:mx-[calc(50%-50vw)] after:w-screen after:h-[1px] after:bg-white"
            : ""
        }`}
      >
        <div
          className={`mr-[8px] ${
            isMobile
              ? "text-[24px] leading-[24px]"
              : "text-[36px] leading-[36px]"
          }`}
        >
          {count}
        </div>
        <div
          className={`w-[40px] h-[40px] flex justify-center items-center ${
            isMobile ? "mr-[-8px]" : ""
          }`}
        >
          <button
            className={styles["button"]}
            type="button"
            onClick={onClickShuffle}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.3662 13.195C16.2553 13.1127 16.1058 13.1029 15.9854 13.17C15.8651 13.2377 15.7956 13.3694 15.8068 13.5071L15.9027 14.6066C15.4364 14.5389 15.0133 14.4336 14.6241 14.2959C14.1032 14.1107 13.6397 13.8681 13.2082 13.5753C12.5623 13.1362 11.9879 12.5782 11.4482 11.9323C11.2414 11.6855 11.0402 11.4256 10.8418 11.1562C10.7328 11.3184 10.6265 11.4783 10.5269 11.6311C10.1471 12.2068 9.73994 12.8095 9.2915 13.4014C9.6967 13.902 10.1376 14.3895 10.6331 14.8421C11.4059 15.5487 12.3151 16.1706 13.3896 16.6069C14.1559 16.919 15.0029 17.1314 15.9299 17.2283L15.8068 18.6366C15.7955 18.7739 15.8651 18.9059 15.9854 18.9732C16.1058 19.0409 16.2553 19.031 16.3662 18.9488L19.8579 16.3534C19.9472 16.2871 19.9999 16.1828 19.9999 16.0718C19.9999 15.9609 19.9472 15.8561 19.8579 15.7898L16.3662 13.195Z"
                fill="white"
              />
              <path
                d="M3.01508 6.722C3.535 6.90723 3.99941 7.14977 4.43 7.44262C5.07684 7.88168 5.65125 8.43965 6.19094 9.08508C6.39777 9.33235 6.59894 9.59231 6.79734 9.86164C6.90641 9.69899 7.01172 9.53961 7.1123 9.38684C7.49121 8.81106 7.89828 8.20887 8.34769 7.61653C7.9425 7.1159 7.50156 6.62844 7.00609 6.17571C6.23328 5.46922 5.32414 4.8468 4.24953 4.41106C3.17492 3.9734 1.94332 3.72758 0.55375 3.72852H0V6.32801H0.55375C1.52211 6.32899 2.32031 6.47567 3.01508 6.722Z"
                fill="white"
              />
              <path
                d="M11.2697 9.3033C11.6241 8.86096 11.9936 8.45432 12.3866 8.09564C12.977 7.55697 13.6163 7.12541 14.3684 6.81939C14.8272 6.63369 15.3321 6.49264 15.9027 6.41041L15.8069 7.51088C15.7956 7.64861 15.8652 7.78025 15.9855 7.84791C16.1059 7.9151 16.2554 7.90525 16.3663 7.82299L19.858 5.22814C19.9473 5.16185 20 5.05701 20 4.94611C20 4.83517 19.9473 4.7308 19.858 4.66451L16.3663 2.0692C16.2554 1.98693 16.1059 1.97705 15.9855 2.04474C15.8652 2.11201 15.7956 2.24408 15.8069 2.38131L15.93 3.7892C15.1479 3.87146 14.4211 4.03459 13.7536 4.27244C13.0136 4.53521 12.3461 4.88498 11.7463 5.29303C10.8466 5.90502 10.1011 6.64307 9.45328 7.41775C8.80551 8.19291 8.25176 9.00709 7.73375 9.79494C7.28812 10.4718 6.8425 11.1248 6.36957 11.7147C6.01512 12.1571 5.64566 12.5633 5.25266 12.9224C4.66223 13.4611 4.02293 13.8922 3.27082 14.1987C2.51773 14.5037 1.6434 14.689 0.553711 14.6899H0V17.2894H0.55375C1.78914 17.2903 2.89945 17.0967 3.8857 16.7456C4.62465 16.4828 5.29313 16.133 5.89199 15.725C6.79266 15.113 7.53727 14.3749 8.18504 13.6003C8.83375 12.8251 9.3875 12.0109 9.90555 11.2231C10.3502 10.5457 10.7968 9.89322 11.2697 9.3033Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeneListTabsArea;
